import { LaneGroup } from './laneGroups';

const firstFilled = (labels: readonly string[]): string | null =>
  labels.find((label) => label.trim().length > 0) ?? null;

/** 見出しに出す地点。表示項目の「積地」「降地」がそのまま入る */
export type LaneLabelParts = { origin: boolean; destination: boolean };

/**
 * レーンカードの見出し。
 *
 * 既定（`parts` を渡さない呼び出し元）は降地の名称だけを出す。
 * Why not 常に「積地 → 降地」の区間表記: 右パネルの幅（実測 291px）では両端とも
 * 省略記号に埋もれ、肝心の降地が読めなくなる（ユーザー判断）。
 *
 * `parts` を渡すと表示項目の ON/OFF に従う（ユーザー判断 2026-09-28）。地点単位では
 * 「積地」「降地」のトグルが押せるのに効かず、押しても何も変わらない状態だった。
 * 幅が足りないときに省略されるのは、利用者が積地を出すと決めたうえでの結果になる。
 *
 * 引けない側は無いものとして扱い、両方引けないときだけ — を出す。ON にした側が
 * 引けなくても見出しが空にならないよう、もう片方で代替する。
 * 複数あっても先頭で代表するのは、同一レーンでも名称が揺れることがあり
 * （住所は同じで表記違いなど）、全件連結すると幅を食うため。
 */
export function buildLaneLabel(group: LaneGroup, parts?: LaneLabelParts): string {
  const origin = firstFilled(group.originLabels);
  const destination = firstFilled(group.destinationLabels);
  if (parts?.origin && parts.destination && origin && destination) {
    return `${origin} → ${destination}`;
  }
  if (parts?.origin && !parts.destination) return origin ?? destination ?? '—';
  return destination ?? origin ?? '—';
}
